import { io } from "socket.io-client";

const chatUrl = "https://crud.apisdevf.net/chatbot";
export const ChatSocket = io(chatUrl, { autoConnect: false });

const videoStreamUrl = "http://localhost:80/videoStream"
export const VideoSocket = io(videoStreamUrl, { autoConnect: false });

const workspaceUrl = "https://api.apisdevf.net/workspace"
export const WorkspaceSocket = io(workspaceUrl, { autoConnect: false });